<template>
    <div class="row">
        <div class="col-6 offset-3">
            <div class="card" v-if="!isValidCallback">
                <div class="card-body text-center">
                    <h2><span class="fa fa-spinner fa-spin text-muted"></span></h2>
                </div>
            </div>
            <div class="card" v-if="isValidCallback">
                <div class="card-body">
                    <h2 class="text-center mb-3">
                        <span class="fa fa-check text-success mr-1"></span>
                        Thank you for your payment
                    </h2>
                    <p style="font-size: 1.3em;">
                        If you have any questions, feel free to call our friendly team on 01904 468 881, or alternatively you can visit 
                        <a href="https://www.surveys4you.co.uk/">our website</a> to find out more.
                    </p>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import { getCheckoutSessionFromStorage } from '../../utils/utils'

    export default {
        data() {
            return {
                isValidCallback: false
            }
        },
        mounted() {
            let stripeSessionId = this.$route.query.session
            let sessionRecord = getCheckoutSessionFromStorage(stripeSessionId)

            if (!sessionRecord) {
                window.location.href = 'https://www.surveys4you.co.uk/'
                return
            }

            sessionRecord.is_complete = true
            localStorage.setItem(stripeSessionId, JSON.stringify(sessionRecord))            
            this.isValidCallback = true

            // Update the job record for those looking by job_ref
            let jobRecordKey = `CHECKOUT_SESSION_${sessionRecord.job_ref}`
            let jobRecord = getCheckoutSessionFromStorage(jobRecordKey)
            if (jobRecord) {
                jobRecord.is_complete = true
                localStorage.setItem(jobRecordKey, JSON.stringify(jobRecord))
            }
        }        
    }
</script>